// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_2Q5r3-QKgxXCJUelOk32dg","externalId":"BAj_hiS4VYFQvPqxoFMjC"};